/* Ported from panel.davakhoone.com (TipTap 3 / Vue 3) to TipTap 2 / Vue 2 for sakhtineo. */
const VOID_TAGS = new Set([
  'area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input',
  'link', 'meta', 'param', 'source', 'track', 'wbr'
])

const INLINE_TAGS = new Set([
  'a', 'abbr', 'b', 'bdi', 'bdo', 'br', 'cite', 'code', 'data', 'dfn',
  'em', 'i', 'kbd', 'mark', 'q', 's', 'samp', 'small', 'span', 'strong',
  'sub', 'sup', 'time', 'u', 'var', 'wbr'
])

function escapeAttr(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
}

function serializeAttrs(el) {
  if (!el.attributes?.length) return ''
  return Array.from(el.attributes)
    .map((attr) => ` ${attr.name}="${escapeAttr(attr.value)}"`)
    .join('')
}

function isIgnorableText(text) {
  return !String(text || '').replace(/\s+/g, '').length
}

function serializeNode(node, depth, indentSize) {
  const pad = ' '.repeat(depth * indentSize)

  if (node.nodeType === Node.COMMENT_NODE) {
    return `${pad}<!--${node.data}-->\n`
  }

  if (node.nodeType === Node.TEXT_NODE) {
    const text = String(node.textContent || '').replace(/\s+/g, ' ').trim()
    return text ? `${pad}${text}\n` : ''
  }

  if (node.nodeType !== Node.ELEMENT_NODE) return ''

  const tag = node.tagName.toLowerCase()
  const attrs = serializeAttrs(node)
  const children = Array.from(node.childNodes).filter((child) => {
    if (child.nodeType === Node.TEXT_NODE) return !isIgnorableText(child.textContent)
    return child.nodeType === Node.ELEMENT_NODE || child.nodeType === Node.COMMENT_NODE
  })

  if (VOID_TAGS.has(tag)) {
    return `${pad}<${tag}${attrs}>\n`
  }

  if (!children.length) {
    return `${pad}<${tag}${attrs}></${tag}>\n`
  }

  const onlyText = children.length === 1 && children[0].nodeType === Node.TEXT_NODE
  if (onlyText && INLINE_TAGS.has(tag)) {
    const text = String(children[0].textContent || '').replace(/\s+/g, ' ').trim()
    return `${pad}<${tag}${attrs}>${text}</${tag}>\n`
  }

  if (onlyText) {
    const text = String(children[0].textContent || '').replace(/\s+/g, ' ').trim()
    if (text.length < 80) {
      return `${pad}<${tag}${attrs}>${text}</${tag}>\n`
    }
  }

  let out = `${pad}<${tag}${attrs}>\n`
  for (const child of children) {
    out += serializeNode(child, depth + 1, indentSize)
  }
  out += `${pad}</${tag}>\n`
  return out
}

/** Pretty-print HTML for the editor source mode */
export function beautifyHtml(html, indentSize = 2) {
  const raw = String(html || '').trim()
  if (!raw || typeof document === 'undefined') return raw

  const wrap = document.createElement('div')
  wrap.innerHTML = raw

  return Array.from(wrap.childNodes)
    .map((node) => serializeNode(node, 0, indentSize))
    .join('')
    .trim()
}
